import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { patchCurrentUser } from 'src/state/users'
import { LanguageCode, MenuSection, UserPatchType } from '@meniudigital/shared'
import { SECTION_OPTIONS } from '../../CategoryModal'
import { categoriesSelector } from 'src/state/selectors'
import wait from 'src/helpers/wait'
import Setting from '../Setting'

export default function DraftSetting() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)
  const { list: categories } = useSelector(categoriesSelector)
  const [isLoading, setIsLoading] = useState(false)

  if (!user) {
    return null
  }

  const cacheAllMenuVariations = async () => {
    const userSections = SECTION_OPTIONS.filter(x => categories.find(y => (y.type || MenuSection.Restaurant) === x.value))
    const userLanguages = user?.menuLanguages?.length ? user.menuLanguages : [LanguageCode.English, LanguageCode.Romanian]

    for (const section of userSections) {
      for (const languageCode of userLanguages) {
        const menuUrl = `${process.env.REACT_APP_MENU_BASE_URL}/${user.username}?s=${section.value}&l=${languageCode}`
        await fetch(menuUrl)
        await wait(200)
      }
    }
  }

  const confirmToggle = async () => {
    if (!user.inDraftMode) {
      await window.showModal({
        title: `Dezactivare actualizări automate`,
        text: `Ești sigur că dorești oprirea actualizărilor în timp real?\n\nAceastă acțiune va crea un snapshot care va fi servit către clienți până când actualizările automate vor fi repornite.`,
        confirmButtonText: 'Da, oprește',
        cancelButtonText: 'Nu',
      })
    } else {
      await window.showModal({
        title: `Activare actualizări în timp real`,
        text: `Ești sigur că dorești repornirea actualizărilor în timp real?\n\nOdată repornite, nu vei putea reveni la snapshotul curent.`,
        confirmButtonText: 'Da, repornește',
        cancelButtonText: 'Nu',
      })
    }
  }

  const toggleDraftMode = async () => {
    if (!user.inDraftMode) {
      setIsLoading(true)
      await cacheAllMenuVariations()
      setIsLoading(false)
      const payload = {
        type: UserPatchType.InDraftMode,
        data: true,
      }
      dispatch(patchCurrentUser(payload as any))
      await window.showConfirm({
        text: `Modificările în timp real au fost oprite. Un snapshot al meniului tău a fost salvat cu succes.`,
      })
    } else {
      const payload = {
        type: UserPatchType.InDraftMode,
        data: false,
      }
      dispatch(patchCurrentUser(payload as any))
      await window.showConfirm({
        text: `Modificările în timp real au fost repornite.`,
      })
    }
  }

  return (
    <Setting
      title="Actualizări în Timp Real"
      icon={
        <img
          src="/icons/realtime-updates.png"
          alt="Realtime updates icon"
          style={user.inDraftMode ? { filter: 'saturate(0)' } : {}}
        />
      }
      isEnabled={!user?.inDraftMode}
      onBeforeToggle={confirmToggle}
      onToggle={toggleDraftMode}
      toggleTexts={{ on: 'Active', off: 'Dezactivate', loading: 'Se dezactivează...' }}
      isLoading={isLoading}
      infoText={
        user?.inDraftMode
          ? 'Actualizările în timp real sunt oprite!'
          : 'Poți opri actualizările în timp real pentru a efectua modificări meniului tău fără ca acestea să fie propagate către clienți.'
      }
      infoVariant={user?.inDraftMode ? 'warning' : undefined}
      alwaysShowsBody
      withBullet
    />
  )
}
